import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class PaymentOrdersHoursTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      payment_date: '',
      id: this.props.payment_order_id,
      payment_order_payments_hours: [],
    };

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.deletePaymentOrderPayment = this.deletePaymentOrderPayment.bind(this);
    this.export = this.export.bind(this);

    this.locale = getLocale();
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.id === 'undefined' && typeof newProps.payment_order_id !== 'undefined') {
      this.setState({
        id: newProps.payment_order_id,
      });
    }
    if(Array.isArray(newProps.payment_order_payments_hours)) {
      this.setState({payment_order_payments_hours: newProps.payment_order_payments_hours});
    }
  }


  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        {
          (this.props.payment_order_data.status === 'aberto') ?
            <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletePaymentOrderPayment}>
              <i className="fa fa-fw fa-trash"></i>
            </button>
            :
            <button className="btn btn-sm btn-danger" value={cell} disabled>
              <i className="fa fa-fw fa-trash"></i>
            </button>
        }
      </div>
    );

    return botao;
  }

  deletePaymentOrderPayment (event) {
    var payment_order_payment_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.deletar);
    if (confirm) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/ordem/pagamento/deletar/pagamento/' + payment_order_payment_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshHours(responseJson);
          } else if (responseJson.status === 'warning') {
            if(window.confirm(responseJson.message)) {
              Promise.resolve(header).then(function(value) {
                fetch(config.get('api') + '/ordem/pagamento/confirmar/deletar/pagamento/' + payment_order_payment_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
                  self.refs.request_api.validate(responseJson, 'alert');
                  if (responseJson.status === 'success') {
                    self.props.refreshTransport(responseJson);
                  } else {
                    self.props.handleAlert(responseJson.message, responseJson.status, 'open');
                  }
                }).catch((error) => {
                  console.error(error);
                });
              });
            }
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  export(event) {
    var url = event.currentTarget.value;
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <hr/>
  <button className="btn btn-success btn-block" value={'/exportar/ordem-de-pagamento/horas/'+this.state.id} onClick={this.export}>
    <i className="fa fa-fw fa-table"></i> {this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.botaoExportarHoras}
  </button>
  <hr/>
  <BootstrapTable data={this.state.payment_order_payments_hours} pagination={true} striped={true} hover={true} options={{noDataText: this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.semPagamentosEmAberto}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.Acoes}</TableHeaderColumn>
    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="outdated_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.Status}</TableHeaderColumn>
    <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.Nome}</TableHeaderColumn>
    <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.Periodo}</TableHeaderColumn>
    <TableHeaderColumn dataField="hours_paid_in_hours" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.HorasPagas}</TableHeaderColumn>
    <TableHeaderColumn dataField="hour_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.ValorDaHora}</TableHeaderColumn>
    <TableHeaderColumn dataField="hours_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tabela.TotalPago}</TableHeaderColumn>
  </BootstrapTable>
</div>
    );
  }
}

export default PaymentOrdersHoursTab;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/Elements/PaymentOrdersHoursTab.js